import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { useListings } from '@/hooks/useListings';
import type { ListingFilters } from '@/api/listings';
import { formatCurrency } from '@/utils/format';

export function SearchPage() {
  const { t } = useTranslation();
  const [filters, setFilters] = useState<ListingFilters>({});
  const [draft, setDraft] = useState<ListingFilters>({});
  const listings = useListings(filters);

  const apply = () => setFilters(draft);

  return (
    <div className="space-y-4">
      <Card title={t('web.nav.search')}>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-4">
          <Input
            label={t('listings.city')}
            value={draft.city ?? ''}
            onChange={(e) => setDraft({ ...draft, city: e.target.value || undefined })}
          />
          <Input
            label={t('listings.rooms')}
            type="number"
            value={draft.rooms ?? ''}
            onChange={(e) =>
              setDraft({ ...draft, rooms: e.target.value ? Number(e.target.value) : undefined })
            }
          />
          <Input
            label={t('listings.price_min')}
            type="number"
            value={draft.price_min ?? ''}
            onChange={(e) =>
              setDraft({ ...draft, price_min: e.target.value ? Number(e.target.value) : undefined })
            }
          />
          <Input
            label={t('listings.price_max')}
            type="number"
            value={draft.price_max ?? ''}
            onChange={(e) =>
              setDraft({ ...draft, price_max: e.target.value ? Number(e.target.value) : undefined })
            }
          />
        </div>
        <Button className="mt-3" onClick={apply}>
          {t('common.search')}
        </Button>
      </Card>

      {listings.isLoading ? <Spinner /> : null}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {listings.data?.data.map((l) => (
          <Link key={l.id} to={`/search/${l.id}`}>
            <Card className="h-full hover:border-brand">
              {l.photos[0]?.url ? (
                <img
                  src={l.photos[0].url}
                  alt={l.title}
                  className="mb-2 h-40 w-full rounded-lg object-cover"
                />
              ) : null}
              <h3 className="text-sm font-semibold">{l.title}</h3>
              <p className="text-xs text-slate-500">{l.address}</p>
              <p className="mt-2 text-sm font-semibold text-brand">
                {formatCurrency(l.monthly_rate)}
              </p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
